export default __webpack_public_path__ + "static/media/Shadow's Armbands of the Final Way.87bd037b.jpg";